import React from 'react';
import { Info } from 'lucide-react';
interface QuoteBoxProps {
  children: React.ReactNode;
  title?: string;
}
export function QuoteBox({
  children,
  title
}: QuoteBoxProps) {
  return <div className="my-8 bg-[#e0f2fe] border-l-4 border-[#0369a1] p-6 rounded-r-lg" data-id="element-55">
      {title && <div className="flex items-center gap-2 mb-3 text-[#0369a1] font-bold" data-id="element-56">
          <Info size={20} data-id="element-57" />
          <span className="uppercase tracking-wide text-sm" data-id="element-58">{title}</span>
        </div>}
      <div className="text-gray-800 text-lg italic leading-relaxed font-medium" data-id="element-59">
        {children}
      </div>
    </div>;
}